import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCardIcon, FacebookIcon, MailIcon, RssIcon, UsersRoundIcon, YoutubeIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerInfo } from '../data/homepage';
const heading = 'font-display text-2xl font-extrabold tracking-tight text-ville-lime';
const social = 'grid h-9 w-9 place-items-center rounded-full bg-ville-spring text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring focus-visible:ring-offset-2 focus-visible:ring-offset-ville-navy';
export function Footer() {
  return <footer className="w-full bg-ville-navy text-white" data-id="element-1162" data-mp="3lgonyijc22op">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-14 text-center lg:grid-cols-3 lg:px-10" data-id="element-1163" data-mp="3qc40n75ltsjj">
        <div data-id="element-1164" data-mp="29xlz0k1buwgz">
          <h2 className={heading} data-id="element-1165" data-mp="29xvqkc20tbos">Address</h2>
          <p className="mt-4 font-bold" data-id="element-1166" data-mp="2eyt8cnj4c3pr">{footerInfo.name}</p>
          {footerInfo.address.map(line => <p key={line} className="text-white/90" data-id="element-1167" data-mp="3l8qwa43iojrg">
              {line}
            </p>)}
          <p className="mt-6 flex justify-center" data-id="element-1168" data-mp="3gb8xh6j7rkx6">
            <Logo variant="light" data-id="element-1169" data-mp="3gctqgrpvqvsx" />
          </p>
        </div>

        <div data-id="element-1170" data-mp="3v8hou08iooow">
          <h2 className={heading} data-id="element-1171" data-mp="3v919hopjxr6m">Contact</h2>

          <dl className="mt-4 space-y-4" data-id="element-1172" data-mp="3q8wu620dr2hz">
            <div className="flex items-start justify-center gap-3 text-left" data-id="element-1173" data-mp="3q725cclzmq8m">
              <MailIcon className="mt-0.5 h-6 w-6 shrink-0" aria-hidden="true" data-id="element-1174" data-mp="81ywcgswhu2x" />
              <div className="min-w-0" data-id="element-1175" data-mp="34gxxkciex96">
                <dt className="font-bold text-ville-lime" data-id="element-1176" data-mp="33e4b4nsygpk">Inquiry Email:</dt>
                <dd data-id="element-1177" data-mp="hrs8biwygb7p">
                  <a href={`mailto:${footerInfo.inquiryEmail}`} className="break-all text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline" data-id="element-1178" data-mp="hsadx65ic1sa">
                    {footerInfo.inquiryEmail}
                  </a>
                </dd>
              </div>
            </div>

            <div className="flex items-start justify-center gap-3 text-left" data-id="element-1179" data-mp="twfovvf7rzsy">
              <CreditCardIcon className="mt-0.5 h-6 w-6 shrink-0" aria-hidden="true" data-id="element-1180" data-mp="ytei8br202q3" />
              <div className="min-w-0" data-id="element-1181" data-mp="13tkanu55dt98">
                <dt className="font-bold text-ville-lime" data-id="element-1182" data-mp="13rps2mhcmd8b">Payment Email:</dt>
                <dd data-id="element-1183" data-mp="18k98dr7f7mgt">
                  <a href={`mailto:${footerInfo.paymentEmail}`} className="break-all text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline" data-id="element-1184" data-mp="18lk91i5kke3p">
                    {footerInfo.paymentEmail}
                  </a>
                </dd>
              </div>
            </div>
          </dl>

          <p className="mt-5 font-bold" data-id="element-1185" data-mp="1rid1jc6wxawz">
            No Charge:{' '}
            <a href={`tel:${footerInfo.tollFree}`} className="font-normal hover:text-ville-spring" data-id="element-1186" data-mp="3obwzv73o0ms8">
              {footerInfo.tollFree}
            </a>
          </p>
          <p className="font-bold" data-id="element-1187" data-mp="3tc2umw58epej">
            Phone:{' '}
            <a href={`tel:${footerInfo.phone}`} className="font-normal hover:text-ville-spring" data-id="element-1188" data-mp="2afwzir5zft1r">
              {footerInfo.phone}
            </a>
          </p>

          <ul className="mt-5 flex justify-center gap-3" data-id="element-1189" data-mp="21ma9lhoghk0h">
            <li data-id="element-1190" data-mp="21kpenqy8bz23">
              <a href="#accueil" aria-label="News feed" className={social} data-id="element-1191" data-mp="21kfqm8wqw1z1">
                <RssIcon className="h-4 w-4" aria-hidden="true" data-id="element-1192" data-mp="1wpjtiucniof2" />
              </a>
            </li>
            <li data-id="element-1193" data-mp="2td6kwduvbgln">
              <a href="#accueil" aria-label="Facebook" className={social} data-id="element-1194" data-mp="2tbn50od4j7ke">
                <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-1195" data-mp="2pd5vxza57n0c" />
              </a>
            </li>
            <li data-id="element-1196" data-mp="2kbgmup6hdjew">
              <a href="#accueil" aria-label="YouTube" className={social} data-id="element-1197" data-mp="2kf4fzn80k3t3">
                <YoutubeIcon className="h-4 w-4" aria-hidden="true" data-id="element-1198" data-mp="2fdykxiqvs4ge" />
              </a>
            </li>
          </ul>

          <div className="mt-5 flex flex-wrap justify-center gap-3" data-id="element-1199" data-mp="18vrx5q1ue6ae">
            <Link to="/my-dashboard" className="inline-flex items-center gap-2 rounded-full bg-ville-blue px-4 py-2 text-sm font-bold text-white transition-colors duration-150 ease-ville hover:bg-ville-spring hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1200" data-mp="13xgnpgfglxsp">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-white font-display text-[13px] font-extrabold leading-none text-ville-blue" aria-hidden="true" data-id="element-1201" data-mp="2ntw8si8qsp59">
                b
              </span>
              My Account
            </Link>
            <a href="#accueil" className="inline-flex items-center gap-2 rounded-full bg-ville-blue px-4 py-2 text-sm font-bold text-white transition-colors duration-150 ease-ville hover:bg-ville-spring hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1202" data-mp="31lsuo4jti2t7">
              <UsersRoundIcon className="h-4 w-4" aria-hidden="true" data-id="element-1203" data-mp="1v69wmllg8c6s" />
              Employee
            </a>
          </div>
        </div>

        <div data-id="element-1204" data-mp="1nnshnzut056f">
          <h2 className={heading} data-id="element-1205" data-mp="1in4q9d2nxmbo">Hours of Operation:</h2>
          {footerInfo.hours.map(line => <p key={line} className="mt-1 text-white/90" data-id="element-1206" data-mp="1wmdy9pgpta4k">
              {line}
            </p>)}

          <h2 className={`mt-6 ${heading}`} data-id="element-1207" data-mp="1rn1c76xo4731">Regional</h2>
          <ul className="mt-2 space-y-1" data-id="element-1208" data-mp="1rlgdd54bm1zd">
            {footerInfo.regional.map(label => <li key={label} data-id="element-1209" data-mp="13vvu0l4992pk">
                <a href="#accueil" className="text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline" data-id="element-1210" data-mp="zwn2zo0lnixp">
                  {label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15" data-id="element-1211" data-mp="l6fhezfapjss">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-5 py-5 text-sm lg:px-10" data-id="element-1212" data-mp="l54dmzluoc1o">
          <p className="font-semibold" data-id="element-1213" data-mp="2gb5fhtt09lmy">© 2026 {footerInfo.name}</p>
          <p className="font-bold" data-id="element-1214" data-mp="2g8sxxhr5tdaf">
            Powered by{' '}
            <a href="#accueil" className="text-ville-spring underline-offset-4 hover:underline" data-id="element-1215" data-mp="2l8f8tkjimhg2">
              {footerInfo.poweredBy}
            </a>
          </p>
        </div>
      </div>
    </footer>;
}